import { U21Button, U21ButtonProps } from 'app/shared/u21-ui/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import { fieldsWithPrefixDeleted } from 'app/modules/fincenSAR/sliceFincenSar';
import { selectFormIsDisabled } from 'app/modules/fincenSAR/selectors';

interface SarDeleteButtonProps extends U21ButtonProps {
  arrayPrefix: string;
  lastElmPrefix: string;
}

export const SarDeleteButton = (props: SarDeleteButtonProps) => {
  const dispatch = useDispatch();
  const { onClick, arrayPrefix, lastElmPrefix, disabled } = props;
  const formDisabled = useSelector(selectFormIsDisabled);

  if (formDisabled) {
    return null;
  }
  return (
    <U21Button
      {...props}
      onClick={(evt) => {
        batch(() => {
          if (arrayPrefix) {
            dispatch(fieldsWithPrefixDeleted(arrayPrefix));
          }
          // Remove touched for last element to clean state for newly added elements
          if (lastElmPrefix) {
            dispatch(fieldsWithPrefixDeleted(lastElmPrefix));
          }
        });
        onClick?.(evt);
      }}
      disabled={disabled}
    />
  );
};
